<script>
import BenefitIcon from '@/components/icons/BenefitIcon.vue'
export default {
  name: 'BenefitBlock',
  props: ['headline', 'subhead', 'bgColor', 'icon'],
  components: {
    BenefitIcon,
  },
}
</script>

<template>
  <v-col class="benefit-block" cols="12" md="6">
    <v-row>
      <v-col class="pa-0 ma-0" cols="12" md="6">
        <BenefitIcon :bgColor="bgColor" :icon="icon" />      
      </v-col>
      <v-col class="pa-0 ma-0" cols="12" md="8">
        <h3>{{ headline }}</h3>
        {{ subhead }}
      </v-col>
    </v-row>
  </v-col>
</template>

<style lang="scss" scoped>
.benefit-block {
  font-size: 16px;
  text-align: left;
}
.benefit-block h3 {
  color: $hpp-darkblue;
  font-weight: 400;
  font-size: 26px;
}
@media only screen and (max-width: 960px) {
  .benefit-block {
    text-align: center;
    padding-left: 15px;
    padding-right: 15px;
    max-width: 60%;
  }
}
@media only screen and (max-width: 600px) {
  .benefit-block {
    max-width: 80%;
  }
}
</style>
